export const QuestionData = [
    {
        id: 1,
        title: "새로운 고양이를 데려왔다! 나의 반응은?",
        answera: "머해? 오디가? 자꾸 말을 걸고 쓰다듬는다",
        answerb: "혼자만의 시간이 필요하지? 적응할 시간을 준다.",
        type: "EI",
      },
      {
        id: 2,
        title: "같은 집사 친구가 고양이가 아픈 것 같아 슬퍼하고있다. 나의 반응은?",
        answera:
          "'병원에 가보는건 어때?' 해결책을 함께 생각하며 정보들은 같이 찾아본다.",
        answerb: "'아이고,, 어쩌면 좋아..' 일단 먼저 위로를 해준다.",
        type: "TF",
      },
      {
        id: 3,
        title: "아무리봐도 우리 고양이가 정말 이쁜 것 같다. 나의 행동은?",
        answera:
          "'사람들한테 자랑해야지..!!'하며 인스타를 만들어서 소통한다.",
        answerb: "우리 고양이 너무 이쁘다.. 사진찍어서 사진첩에 간직한다.",
        type: "EI",
      },
      {
        id: 4,
        title: "고양이를 키우는데 가족과의 마찰이 생겼다. 이럴땐?",
        answera:
          "나의 생각과 논리가 맞다는 걸 증명하기 위해 가족들에게 먼저 설명한다.",
        answerb:
          "나의 의견이 상대방을 기분 나쁘게 하지 않도록 잘 전달하려고 먼저 생각한다.",
        type: "TF",
      },
      {
        id: 5,
        title: "고양이 사료를 급여하는 방법은?",
        answera:
          "'우리 고양이 몸무게는 5키로니까 하루 몇시에 이만큼 씩 줘야지' 계획을 세운다. ",
        answerb: "사료주면 알아서 먹겠지! 일단 자율급식으로 한꺼번에 줘본다.",
        type: "JP",
      },
      {
        id: 6,
        title: "고양이 밥을 주려고 한다 나의 방법은?",
        answera: "손,눈대중으로 대충 이정도면 되겠지 하고 급여한다.",
        answerb: "칼로리를 정확히 맞춰 저울이나 스푼으로 계랑해서 급여한다.",
        type: "SN",
      },
      {
        id: 7,
        title: "고양이에 대한 모든 것이 궁금해졌다. 나의 행동은?",
        answera:
          "고양이 관련 커뮤니티에 들어 다른 집사님들과 소통을 하며 고양이에 대한 지식을 쌓는다.",
        answerb:
          "커뮤니티에 가입은 하지만 눈으로 참고만 하고 혼자 찾아보는게 편하다.",
        type: "EI",
      },
      {
        id: 8,
        title: "고양이 유튜브를 시작하려고 한다. 나는 어떤 유튜브를 만들고 싶은가?",
        answera: "다른 유튜버들을 가이드 라인 삼아 비슷하게 만든다.",
        answerb: "새롭거나 자유로운 방식으로 만들기 위해 생각한다.",
        type: "SN",
      },

      {
        id: 9,
        title: "고양이가 아파서 병원을 고르려고 리뷰를 보았다. 내가 갈 병원은?",
        answera: "시설이 중요하지!! 좋은 시설의 대형 병원",
        answerb: "사람이 중요하지!! 원장님의 성격이 좋은 동네 병원",
        type: "TF",
      },
 
      {
        id: 10,
        title: "고양이 사료가 우연히 여러 종류가 생겼다. 급여방법은?",
        answera:
          "사료를 조금씩 급여해서 테스트 해보고 다 잘먹는다면 날짜에 맞춰서 질리지 않도록 급여한다.",
        answerb: " 끌리는 걸로 그때그때 급여한다.",
        type: "JP",
      },
      {
        id: 11,
        title:
          "고양이에 대해서 모르는 부분들을 검색을 하고 있다. 내가 글을 읽는 방법은?",
        answera: "꼼꼼하게 정확하게 읽는다.",
        answerb: "전체적인 의미를 파악하며 읽는다.",
        type: "SN",
      },
      {
        id: 12,
        title: "자기전 나는?",
        answera: "내일 할 일을 미리미리 정해놓고 잔다.",
        answerb: "누우면 장땡! 일단 누워서 유튜브를 켠다.",
        type: "JP",
      },
]